import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties from '../../models/INFTProperties'
import { ISporeCard } from '../Cards/SporeCard'
import BaseDetail from './BaseDetail'


export default function SporeDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<ISporeCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  const tokenName = `${collection?.name} #${detailTokenItem ? detailTokenItem.name : 0}`

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    const result: INFTProperties[] = []

    if (detailTokenItem) {
      result.push({
        key: 'Author',
        value: detailTokenItem.author,
        show: true,
        isUrl: false
      })
    }
    return result
  }

  return (
    <BaseDetail
      {...props}
      description={detailTokenItem ? <div>{detailTokenItem.description}</div> : undefined}
      tokenItemName={tokenName}
      properites={getNFTProperties()}
    >
      {detailTokenItem ? <img src={detailTokenItem.image} alt={tokenName} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
